/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import i18n from 'i18n';
import {
  createLicenseGroupRequest,
  editLicenseGroupRequest,
} from 'modules/environments/actions';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { Formik } from 'formik';
import GenericForm from 'skyone-lib/lib/GenericForm';
import Button from 'components/Button';
import { LicenseGroupsFields } from 'modules/environments/interfaces';
import { Query } from 'hooks/useTableFilters';
import palette from 'theme/palette';
import screenFields from './screenFields';
import ListClients from './ListClients';
import Schema from './schema';
import styles, { overrideModal } from './styles';

const useStyles = makeStyles(styles);

interface Props {
  initialValues?: LicenseGroupsFields;
  queryGroups: Query;
  licenseLimitAvailable: number;
  isCreate?: boolean;
  createLicenseGroupRequest: (props) => void;
  editLicenseGroupRequest: (props) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
}

const FormLicenseGroups = ({
  initialValues,
  queryGroups,
  licenseLimitAvailable,
  isCreate,
  createLicenseGroupRequest,
  editLicenseGroupRequest,
  modalOpen,
  modalClose,
}: Props) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();

  const handleOpenAddClientsModal = (groupUuid: string) => {
    modalOpen({
      title: i18n.t('ADD_CLIENTS_TO_GROUP_KEY'),
      maxWidth: 'md',
      overrideClasses: overrideModal,
      content: <ListClients queryGroups={queryGroups} groupUuid={groupUuid} />,
    });
  };

  const handleSubmit = (values: any) => {
    createLicenseGroupRequest({
      environmentUuid: id,
      values,
      handleOpenAddClientsModal,
      query: queryGroups,
    });
  };
  const handleEdit = (values: any) => {
    editLicenseGroupRequest({
      environmentUuid: id,
      licenseGroupUuid: initialValues?.uuid,
      values,
      query: queryGroups,
    });
    modalClose();
  };

  return (
    <>
      <Grid container className={classes.availableLicenses}>
        <Typography className={classes.text} component="div">
          {isCreate
            ? `${i18n.t('AVAILABLE_LICENSES_ENVIRONMENT_KEY')}: `
            : `${i18n.t('AVAILABLE_LICENSES_GROUP_KEY')}: `}
          <Box color={palette.blue} fontWeight="bold" display="inline">
            {licenseLimitAvailable}
          </Box>
        </Typography>
      </Grid>
      <Formik
        initialValues={initialValues || { name: '', license_limit: 0 }}
        onSubmit={initialValues ? handleEdit : handleSubmit}
        enableReinitialize
        validationSchema={Schema}
        validateOnBlur
        validateOnChange
      >
        {({ setFieldValue, errors, values, submitForm }) => (
          <Grid
            container
            xs={12}
            justify="space-between"
            style={{ marginTop: 16, marginBottom: 16, alignItems: 'center' }}
          >
            <Grid container spacing={2} style={{ padding: '0px 8px' }}>
              <GenericForm
                fields={values}
                errors={errors}
                screenFields={screenFields}
                setFieldValue={setFieldValue}
                overrideClasses={{
                  selectLabel: { fontSize: 12, fontWeight: 500 },
                }}
              />
            </Grid>
            <Grid
              container
              justify="flex-end"
              style={{ marginTop: 16, marginBottom: -16 }}
            >
              <Grid>
                <Button id="create-button" submitButton onClick={submitForm}>
                  {i18n.t('SAVE_KEY')}
                </Button>
                <Button
                  id="close-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CLOSE_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </>
  );
};

export default connect(null, {
  createLicenseGroupRequest,
  editLicenseGroupRequest,
  modalOpen,
  modalClose,
})(FormLicenseGroups);
